export function hasTaxInclusiveTotal(estimates) {
  if (!Array.isArray(estimates)) {
    return false;
  }

  return estimates.some((estimate) => {
    const projectCost = Number(
      estimate?.project_cost ?? estimate?.projectCost ?? 0,
    );
    const projectCostTax = Number(
      estimate?.project_cost_tax ?? estimate?.projectCostTax ?? 0,
    );

    return projectCostTax > 0 && projectCostTax > projectCost;
  });
}

export function getEstimateDisplayTotal(estimate) {
  const projectCost = Number(
    estimate?.project_cost ?? estimate?.projectCost ?? 0,
  );
  const projectCostTax = Number(
    estimate?.project_cost_tax ?? estimate?.projectCostTax ?? 0,
  );
  const constructionCost = Number(
    estimate?.construction_cost ?? estimate?.constructionCost ?? 0,
  );

  if (projectCostTax > 0) {
    return projectCostTax;
  }

  if (projectCost > 0) {
    return projectCost;
  }

  return constructionCost;
}

export function preferCalculatedTotalWithinRounding(
  calculatedTotal,
  fallbackTotal,
) {
  return Math.abs(calculatedTotal - fallbackTotal) <= 5
    ? calculatedTotal
    : fallbackTotal;
}
